import React from 'react';
import PropTypes from 'prop-types';
import { 
    Field, Fields
} from 'redux-form';
import { FormattedMessage } from 'react-intl';

const FormField = props => {
    const { name, labelId, selectLabelId, floatingLabelId, component, ...custom } = props;
    let labelTextInfo = {};

    // floating label 정보 
    if( floatingLabelId ) {
        labelTextInfo.floatingLabelText = <FormattedMessage id={floatingLabelId}/>;
    }

    // labelText : 텍스트 정보 
    if( labelId ) {
        labelTextInfo.labelText = Array.isArray(labelId) ? 
                labelId.map(label => <FormattedMessage id={label}/>) : <FormattedMessage id={labelId}/>
    }

    // selectLabelText : Selectbox 타이틀
    if( selectLabelId ) {
        labelTextInfo.selectLabelText = <FormattedMessage id={selectLabelId}/>;
    }

    return (
        Array.isArray(name) ? 
            <Fields
                component={component}
                names={name}
                {...labelTextInfo}
                {...custom}
            />
            : 
            <Field 
                component={component}
                name={name}
                {...labelTextInfo}
                {...custom}
            />
    );
};


FormField.propTypes = {
    component: PropTypes.any.isRequired,
    name: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string
    ]).isRequired,
    labelId: PropTypes.oneOfType([   
        PropTypes.array,
        PropTypes.string
    ]), // 텍스트 정보의 FormattedMessage의 id값 (key가 다르고 value가 true/false인 Checkbox일 때는 labelId가 배열)
    selectLabelId: PropTypes.string, // 현재 선택된 데이타 (Selectbox용)
    selectOptions: PropTypes.array, // Selectbox나 Radio버튼의 options 정보 
    floatingLabelId: PropTypes.string, // Floating Label의  FormattedMessage id값
};

export default FormField;